module.exports = __webpack_public_path__ + "img/card.e7e95be2.svg";